class DataError<T> extends Error {
	data: T;
	constructor(message: string, data: T) {
		super(message);
		this.name = 'DataError';
		this.data = data;
	}
}

export default DataError;